import React, { useState, useRef } from 'react';
import { Validaciones } from '@renedelangel/helpers';
import moment from 'moment';

import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

import SaveIcon from '@material-ui/icons/Save';
import Close from "@material-ui/icons/Close";

import { cancelarPolizasSeguro } from '../../../mutations/PolizasSeguro';
import { handleFocus, handleErrorInputText, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger } from '../../../_layout/helpers/colores';

const { trim } = Validaciones;

// Captura de la cancelación de una póliza principal: fecha y motivo
function CancelarPoliza({ poliza, token, onClose, setActualizar, actualizar }) {

    const { polizasSeguroID, numero, folioInterno } = poliza;

    const cleanState = { fechaCancelacion: moment(), motivoCancelacion: "" };
    const cleanErrorState = {
        fechaCancelacion: { error: false, helperText: "" },
        motivoCancelacion: { error: false, helperText: "" }
    };
    const cleanNotificaciones = { mensaje: "", color: null, open: false };

    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [disabled, setDisabled] = useState(false);
    const [loader, setLoader] = useState(false);

    const fechaRef = useRef(null);
    const motivoRef = useRef(null);

    const inputs = [{
        id: "Cancelacion",
        tipo: "fieldset",
        leyenda: `Póliza ${numero || ""} — Folio ${folioInterno || ""}. Una vez cancelada no se considera en nuevos presupuestos, en la duplicación del Programa Anual, en seguimientos ni en avisos de renovación, y no se puede renovar.`,
        grid: { lg: 12 },
        inputs: [
            {
                disabled,
                id: "fechaCancelacion",
                value: state.fechaCancelacion,
                error: errorState.fechaCancelacion.error,
                success: state.fechaCancelacion && !errorState.fechaCancelacion.error ? true : undefined,
                helperText: errorState.fechaCancelacion.helperText,
                inputRef: fechaRef,
                title: "Fecha de cancelación *",
                placeholder: "Fecha de cancelación",
                onlyDate: true,
                tipo: "datetimepicker",
                grid: { md: 4, lg: 4 },
                onChange: (value) => {
                    if (typeof value !== "object") return;
                    setState({ ...state, fechaCancelacion: value });
                }
            },
            {
                disabled,
                id: "motivoCancelacion",
                value: state.motivoCancelacion,
                error: errorState.motivoCancelacion.error,
                success: state.motivoCancelacion && !errorState.motivoCancelacion.error ? true : undefined,
                helperText: errorState.motivoCancelacion.helperText,
                inputRef: motivoRef,
                multiline: true,
                title: "Motivo de la cancelación *",
                placeholder: "Capture el motivo de la cancelación",
                grid: { md: 12, lg: 12 },
                onChange: ({ target: { value } }) => setState({ ...state, motivoCancelacion: value }),
                onKeyDown: () => { return; }
            }
        ]
    }];

    const acciones = [{
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Cancelar póliza",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose: onClose,
            handleFocus,
            refFocus: motivoRef,
            mensajeCorrecto: `La póliza ${numero || ""} se canceló correctamente`,
            asyncCallback: ftCancelar
        })
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cerrar",
        onClick: onClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ fechaCancelacion, motivoCancelacion }) {
        let error;
        [
            {
                condicion: !fechaCancelacion || !moment(fechaCancelacion).isValid(),
                ref: fechaRef, keyError: "fechaCancelacion",
                mensajeError: "Debe indicar la fecha de cancelación"
            },
            {
                condicion: !motivoCancelacion || trim(motivoCancelacion) === "",
                ref: motivoRef, keyError: "motivoCancelacion",
                mensajeError: "Debe indicar el motivo de la cancelación"
            }
        ].forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });
        return error;
    }

    async function ftCancelar() {
        let { fechaCancelacion, motivoCancelacion } = state;

        let error = handleValidaciones({ fechaCancelacion, motivoCancelacion });
        if (error) return error;

        await cancelarPolizasSeguro({
            polizasSeguroID: Number(polizasSeguroID),
            fechaCancelacion: moment(fechaCancelacion).format("YYYY-MM-DD"),
            motivoCancelacion: trim(motivoCancelacion)
        }, token);
    }

    return (
        <FormularioModal
            open={true}
            title="Cancelar Póliza"
            onClose={onClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={acciones}
            focus={motivoRef}
        />
    );
}

export default CancelarPoliza;
